import { Link } from "react-router-dom";
import { ArrowRight, ShieldCheck } from "lucide-react";

export default function FinalCTA() {
    return (
        <section
            data-testid="final-cta-section"
            className="bg-slate-900 text-white"
        >
            <div className="max-w-6xl mx-auto px-6 md:px-12 py-24 md:py-32">
                <div className="max-w-3xl">
                    <h2
                        data-testid="final-cta-headline"
                        className="font-display text-4xl md:text-6xl font-semibold tracking-tighter leading-[1.05]"
                    >
                        1099er:
                        <br />
                        <span className="text-slate-400">
                            Creating Win-Wins for Patients, Surgeons, and Industry Partners.
                        </span>
                    </h2>
                </div>

                <div className="mt-12 flex flex-col sm:flex-row gap-3">
                    <a
                        href="#join"
                        data-testid="final-cta-become-1099er-btn"
                        className="inline-flex items-center justify-center gap-2 bg-white text-slate-900 text-sm md:text-base font-medium px-7 py-3.5 rounded-md hover:bg-slate-100 transition-colors"
                    >
                        Schedule a Confidential Call
                        <ArrowRight size={16} />
                    </a>
                    <a
                        href="/contact"
                        data-testid="final-cta-explore-opps-btn"
                        className="inline-flex items-center justify-center gap-2 bg-transparent text-white border border-white/25 text-sm md:text-base font-medium px-7 py-4 rounded-md hover:bg-white/5 transition-colors"
                    >
                        Contact us
                        <ArrowRight size={16} />
                    </a>
                </div>

                <p
                    data-testid="final-cta-reassurance"
                    className="mt-5 text-sm text-slate-400 flex items-center gap-2"
                >
                    <ShieldCheck size={13} className="text-slate-400" />
                    Free to join. Your relationships stay private.
                </p>
            </div>
        </section>
    );
}
